import { userData } from "../store";
import { useRecoilState } from "recoil";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authApiService } from "../services/auth/authApiService";

export const CheckUserSubscription = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useRecoilState(userData);

  useEffect(() => {
    getUpdatedSubscriptionInfo();
  }, []);

  const getUpdatedSubscriptionInfo = () => {
    authApiService.getUserProfile(userInfo.email).then((res) => {
      setUserInfo(res.data);
      if (res.data.isSubscribed && userInfo?.userRole !== "Property Manager") {
        return true;
      } else navigate("/subscription/retry");
    });
  };
};

export const GetRoleLabel = (role) => {
  const roleMap = {
    "Client Admin": "CA",
    "Property Manager": "PM",
    Landlord: "LL",
    Tenant: "T",
    "Assistant Property Manager": "APM",
    "Maintenance Technician": "MT",
  };
  return roleMap[role] || "User";
};
